module.exports = __webpack_public_path__ + "img/6.592644c1.jpg";